<template lang="html">
  <div class="admin-report-wrapper">
    <div class="title">
      Izveštaji
    </div>
    <div class="time-wrapper">
      <input type="date" v-model="dateFrom">
      <span>-</span>
      <input type="date" v-model="dateTo">
      <div @click="type === 'getExpired' ? getReport() : type = 'getExpired'" class="btn">
        Zatvorene objave
      </div>
      <div @click="type === 'getNew' ? getReport() : type = 'getNew'" class="btn">
        Nove objave
      </div>
      <div @click="type === 'getBoughtOut' ? getReport() : type = 'getBoughtOut'" class="btn">
        Rasprodane objave
      </div>
    </div>
    <div class="table-wrapper">
      <table v-if="result.length > 0">
        <thead>
          <tr>
            <td style="width: 40px">Id</td>
            <td>Naziv objave</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="res in result" :key="res.pro_id">
            <td>
              {{res.pro_id}}
            </td>
            <td>
              {{res.pro_name}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-if="result.length > 0" class="pagination-wrapper">
      <paginate
        v-model="page"
        :page-count="pageCount"
        :prev-text="getPaginationImages('Left')"
        :next-text="getPaginationImages('Right')"
        :container-class="'pagination'"
        :page-class="'page'"
        :click-handler="changePage"
      >
      </paginate>
    </div>
  </div>
</template>

<script>
import { api } from '@/api'
export default {
  name: 'adminReports',
  data () {
    return {
      dateFrom: null,
      dateTo: null,
      result: [],
      page: 1,
      pageCount: 0,
      type: null
    }
  },
  mounted () {
    this.setDates()
  },
  methods: {
    setDates () {
      this.dateFrom = this.$moment().subtract(1, 'months').format('YYYY-MM-DD')
      this.dateTo = this.$moment().format('YYYY-MM-DD')
    },
    getPaginationImages (side) {
      let path = require(`@/assets/icons/pagination${side}.png`)
      return `<img src='${path}' alt='pagination left image'>`
    },
    changePage (page) {
      this.page = page
      this.result = []
      this.getReport()
    },
    getReport () {
      if (this.dateFrom && this.dateTo) {
        let params = {
          start_date: this.dateFrom,
          end_date: this.dateTo,
          page: this.page
        }
        api[this.type](params).then(res => {
          this.result = res.data.data
          this.pageCount = res.data.page_count
        })
      } else {
        console.log('err')
      }
    }
  },
  watch: {
    type: {
      handler: function () {
        this.page = 1
        this.result = []
        this.getReport()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.admin-report-wrapper {
  padding-left: 40px;
  box-sizing: border-box;
  @import '@/assets/scss/btnStyles.scss';
  @import '@/assets/scss/tableStyles.scss';
  height: 100%;
  position: relative;

  .table-wrapper {
    height: calc(100% - 170px);
    overflow: auto;

    table {
      margin-bottom: 2px;
    }
  }

  .title {
    margin-bottom: 25px;
    font-size: 21px;
    color: $text-color;
    text-align: left;
  }
  .time-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 20px;
    flex-wrap: wrap;

    * {
      margin-right: 10px;
      margin-bottom: 10px;
    }
  }
}
</style>
